import api from '../api';
class HorsesService {
    configureHorse(data) {
        return api.post(`/configure/`, data);
    }
    getHorseConfigurator(horseId) {
        return api.get(`/configure/${horseId}`);
    }
    removeConfiguratorSettings(data) {
        return api.post(`/configure/${data.horseAssetName}/delete`, { type: data.type });
    }
    getVisitedUserConfigurations(userId, horseId) {
        return api.get(`/configure/${userId}/${horseId}`);
    }
}
export default new HorsesService();
